<template>
  <div class="container">
    <div class="banner_wrapper">
      <div class="banner_img_content">
        <img class="banner_img" src="@/assets/images/partnerships.png" alt="Banner" />
      </div>
      <div class="banner_content">
        <div class="banner_title">Partnerships</div>
      </div>
    </div>
    <div class="content_wrapper">
      <div class="title">Partnerships</div>
      <div class="description">
        Thank you to all partners who have dedicated themselves to the public welfare cause.
      </div>
      <div class="item_wrapper marquee">
        <div class="marquee_inner">
          <a target="_blank" href="https://www.impactministriesglobal.com/" class="item">
            <img src="@/assets/images/partnerships/Impact_ministries.png" />
          </a>
          <a target="_blank" href="https://www.newmanna.org/" class="item">
            <img src="@/assets/images/partnerships/new_manna_ministries.png" />
          </a>
          <a target="_blank" href="https://waymaker.faith/" class="item">
            <img src="@/assets/images/partnerships/waymaker.png" />
          </a>
          <a target="_blank" href="https://www.seabol.org/" class="item">
            <img src="@/assets/images/partnerships/church_in_seattle.png" />
          </a>
          <a target="_blank" href="https://www.efchh.org/" class="item">
            <img src="@/assets/images/partnerships/evangelical.png" />
          </a>
          <a target="_blank" href="https://www.westgatechapel.com/" class="item">
            <img src="@/assets/images/partnerships/west_gat_chapel.png" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { LoadingOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { computed, ref, reactive, onMounted, toRaw, h, nextTick, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

const route = useRoute();
const store = useStore();

onMounted(() => {});
</script>

<style lang="less" scoped>
.marquee {
  overflow: hidden;
  position: relative;
  .marquee_inner {
    display: flex;
    width: max-content;
    animation: marquee-scroll 16s linear infinite;
  }
  &:hover .marquee_inner {
    animation-play-state: paused;
  }
}
.container {
  .banner_wrapper {
    position: relative;
    margin: 0 auto;
    max-width: 1920px;
    max-height: 500px;
    .banner_img_content {
      padding-bottom: calc(100% * (20 / 192));
      min-height: 200px;
      .banner_img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .banner_content {
      width: 1080px;
      margin: 0 auto;
      position: absolute;
      left: calc(50% - 540px);
      top: 0;
      bottom: 0;
      display: flex;
      .banner_title {
        margin: 80px auto;
        color: #fff;
        font-size: 28px;
        font-weight: bold;
        line-height: 28px;
      }
    }
    @media (max-width: 1080px) {
      .banner_content {
        width: 100%;
        left: 0;
      }
    }
  }
  .content_wrapper {
    width: 1080px;
    margin: 40px auto;
    padding: 10px 80px;
    text-align: center;
    .title {
      font-size: 26px;
      font-weight: bold;
      line-height: 28px;
      margin-bottom: 20px;
    }
    .description {
      font-size: 16px;
      color: #666666;
      line-height: 24px;
      margin-bottom: 40px;
    }
    .item_wrapper {
      margin: 40px auto;
      width: 100%;
      .marquee_inner {
        gap: 30px;
      }
      .item {
        width: 280px;
        height: 95px;
        flex-shrink: 0;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    @keyframes marquee-scroll {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-50%);
      }
    }
  }
  @media (max-width: 1080px) {
    .content_wrapper {
      width: 100%;
      padding: 16px 20px;
      gap: 20px;
      .item_wrapper {
        .item {
          width: 150px;
          height: 70px;
        }
      }
    }
  }
}
</style>
